module.exports = __webpack_public_path__ + "img/excluded_area_blue.e5660790.svg";